import type { CSSProperties, FC } from 'react'

import Image from 'next/image'
import { cn } from '@/lib/utils'

interface PhotoProps {
    src: string
    alt: string
    sizes?: string
    preload?: boolean
    position?: string
    tone?: boolean
    grain?: boolean
    className?: string
    imgClassName?: string
    style?: CSSProperties
}

export const Photo: FC<PhotoProps> = ({
    src,
    alt,
    sizes = '100vw',
    preload = false,
    position,
    tone = true,
    grain = false,
    className,
    imgClassName,
    style
}) => {
    const remote = /^https?:\/\//.test(src)

    return (
        <div
            className={cn('relative overflow-hidden bg-sand', className)}
            style={style}
        >
            <Image
                src={src}
                alt={alt}
                fill
                sizes={sizes}
                preload={preload}
                unoptimized={remote}
                className={cn('object-cover', tone && 'photo-tone', imgClassName)}
                style={position ? { objectPosition: position } : undefined}
            />
            {grain && (
                <span
                    aria-hidden='true'
                    className='grain pointer-events-none absolute inset-0'
                />
            )}
        </div>
    )
}
